// Centralized content for the site — placeholders can be replaced later.

// Asset URLs (uploaded covers)
const ASSETS = {
  magicKolam:
    "https://customer-assets.emergentagent.com/job_meera-adventures/artifacts/tm6u4xrq_ChatGPT%20Image%20Jun%2011%2C%202026%2C%2001_27_10%20PM%20%281%29.png",
  warliWall:
    "https://customer-assets.emergentagent.com/job_meera-adventures/artifacts/arvv5ml8_ChatGPT%20Image%20Jun%2012%2C%202026%2C%2007_20_32%20PM.png",
  gondForest:
    "https://customer-assets.emergentagent.com/job_meera-adventures/artifacts/bjex6x6i_ChatGPT%20Image%20Jun%2016%2C%202026%2C%2006_33_46%20PM.png",
  madhubaniPond:
    "https://customer-assets.emergentagent.com/job_meera-adventures/artifacts/o4zlbttq_ChatGPT%20Image%20Jun%2016%2C%202026%2C%2005_14_02%20PM.png",
  rememberMe:
    "https://customer-assets.emergentagent.com/job_meera-adventures/artifacts/z27wlrmb_ChatGPT%20Image%20Jun%2011%2C%202026%2C%2001_28_40%20PM%20%281%29.png",
  kitchenKhichdi:
    "https://customer-assets.emergentagent.com/job_meera-adventures/artifacts/54k2tfwd_ChatGPT%20Image%20Jun%2011%2C%202026%2C%2001_30_16%20PM%20%281%29.png",
  yogaFoxx:
    "https://customer-assets.emergentagent.com/job_meera-adventures/artifacts/t4amwicz_ChatGPT%20Image%20Jun%2011%2C%202026%2C%2002_03_27%20PM%20%281%29.png",
  meeraGrowing:
    "https://customer-assets.emergentagent.com/job_meera-adventures/artifacts/io5p3bze_ChatGPT%20Image%20Jun%2012%2C%202026%2C%2003_18_36%20PM.png",
  flashJam:
    "https://customer-assets.emergentagent.com/job_meera-adventures/artifacts/iu3biql2_ChatGPT%20Image%20Jun%2011%2C%202026%2C%2006_26_26%20PM.png",
  storyWorld:
    "https://customer-assets.emergentagent.com/job_meera-adventures/artifacts/jdftmeq6_ChatGPT%20Image%20Jun%2011%2C%202026%2C%2001_54_24%20PM%20%281%29.png",
  weMatched:
    "https://customer-assets.emergentagent.com/job_meera-adventures/artifacts/43tlswhq_ChatGPT%20Image%20May%2021%2C%202026%2C%2006_24_21%20PM.png",
  elevenVignettes:
    "https://customer-assets.emergentagent.com/job_meera-adventures/artifacts/zagmx4k4_61kon2wNXPL._SL1335_.jpg",
  portrait:
    "https://customer-assets.emergentagent.com/job_meera-adventures/artifacts/fwfdua8d_divya%20fun.png",
  journey1:
    "https://customer-assets.emergentagent.com/job_meera-adventures/artifacts/8x9pnoah_ChatGPT%20Image%20Jun%209%2C%202026%2C%2011_08_05%20PM.png",
  journey2:
    "https://customer-assets.emergentagent.com/job_meera-adventures/artifacts/rn0e82hf_ChatGPT%20Image%20Jun%2010%2C%202026%2C%2009_14_27%20PM.png",
};

export const SITE = {
  name: "Dr. Divya Ramachandran",
  shortName: "Divya Ramachandran",
  tagline: "Author • Educator • Researcher • Artist • Musician",
  location: "Bangalore, India",
  email: "divya.ovya@gmail.com",
  phone: "+91 99000 63110",
  phoneHref: "tel:+919900063110",
  socials: {
    instagram: "https://www.instagram.com/sierrashine2023/",
    linkedin: "https://www.linkedin.com/in/dr-divya-r/",
    medium: "https://medium.com/@divyaramachandran",
    spotify: "https://open.spotify.com/artist/4fdjZXRvNr9DNhYJMKQIML?si=aKSXOH5KTU-kliz20hhWGw",
    tedx: "https://www.ted.com/talks/divya_ramachandran_using_art_to_ignite_ideas_spur_creativity_and_spread_joy",
  },
};

export const MEERA_BOOKS = [
  {
    id: "magic-kolam",
    title: "Meera and the Magic Kolam",
    artForm: "Kolam — Tamil Nadu",
    ageGroup: "Ages 5–10",
    blurb:
      "Meera wakes before dawn to learn the dot-and-line magic of kolam, the threshold art mothers and grandmothers have drawn for centuries. A story of patterns, patience, and the geometry of welcome.",
    cover: ASSETS.magicKolam,
    purchase: "https://www.amazon.in/Meera-Magic-Kolam-Divya-Ramachandran/dp/9370022805?s=bazaar",
    accent: "#D95D39",
  },
  {
    id: "warli-wall",
    title: "Meera and the Dancing Warli Wall",
    artForm: "Warli — Maharashtra",
    ageGroup: "Ages 6–10",
    blurb:
      "When Meera visits a village in the Sahyadris, the wall behind her grandmother's kitchen begins to move. Triangles dance. Circles sing. The Warli tribe's ancient line-language whispers her name.",
    cover: ASSETS.warliWall,
    purchase: "#",
    comingSoon: true,
    accent: "#1E2A4F",
  },
  {
    id: "madhubani-pond",
    title: "Meera and the Singing Madhubani Pond",
    artForm: "Madhubani — Bihar",
    ageGroup: "Ages 5–10",
    blurb:
      "By a lotus-strewn pond in a Mithila courtyard, Meera meets a peacock that paints itself, fish patterned like jewellery, and a turtle who hums old folk songs. A magical adventure inspired by Madhubani art.",
    cover: ASSETS.madhubaniPond,
    purchase: "#",
    comingSoon: true,
    accent: "#B22234",
  },
  {
    id: "gond-forest",
    title: "Meera and the Whispering Gond Forest",
    artForm: "Gond — Madhya Pradesh",
    ageGroup: "Ages 6–10",
    blurb:
      "A story of lost paths, magical patterns, and finding the way home — Meera follows tiger stripes and turtle shells deep into a Gond forest where every tree and creature is drawn in dots and lines that hum with story.",
    cover: ASSETS.gondForest,
    purchase: "#",
    comingSoon: true,
    accent: "#2E5E3E",
  },
  {
    id: "future",
    title: "More on the way",
    artForm: "Pattachitra, Pichwai & beyond",
    ageGroup: "—",
    blurb:
      "Meera's atlas continues. New journeys through India's living art forms — each book a doorway, each illustration a hand held out to the next generation.",
    cover: ASSETS.meeraGrowing,
    purchase: "#",
    accent: "#E76F51",
    upcoming: true,
  },
];

export const PLAYFUL_BOOKS = [
  {
    id: "play",
    title: "Play",
    label: "Engage with life",
    blurb:
      "A book about reconnecting with curiosity, creativity, experimentation, and play in adulthood. Because life isn't just something to get through — it's something to play with.",
    purchase: "https://www.amazon.in/Play-Engage-Life-Divya-Ramachandran/dp/9371974389",
    image:
      "https://customer-assets.emergentagent.com/job_meera-adventures/artifacts/c7yp5tqe_ChatGPT%20Image%20Jun%2017%2C%202026%2C%2012_48_55%20AM.png",
  },
  {
    id: "think-build-create",
    title: "Think. Build. Create.",
    label: "Unraveling the creative process",
    blurb:
      "A practical and inspiring guide to understanding how ideas take shape, how creative work gets built, and how we bring it all to life. For dreamers, doers, and creators ready to make their ideas real.",
    purchase: "https://www.amazon.in/Think-Build-Create-Unraveling-creative-Divya-Ramachandran/dp/935838087X",
    image:
      "https://customer-assets.emergentagent.com/job_meera-adventures/artifacts/xzj821kv_ChatGPT%20Image%20Jun%2017%2C%202026%2C%2012_51_02%20AM.png",
  },
];

// Generic Amazon search for all of Divya's books
export const AMAZON_SEARCH = "https://www.amazon.in/s?k=divya+ramachandran&i=stripbooks";

export const BOOKSHELF = {
  children: [
    {
      title: "Remember Me",
      subtitle: "Some memories may fade, but love remains — a heartwarming picture book about a grandmother, a granddaughter, and a small brown dog.",
      cover: ASSETS.rememberMe,
      purchase: "https://www.amazon.in/Remember-Me-Divya-Ramachandran/dp/9358389044",
    },
    {
      title: "Kitchen Khichdi",
      subtitle: "A delicious adventure filled with rivalry, mystery, and a secret ingredient that changes everything. For ages 6–10.",
      cover: ASSETS.kitchenKhichdi,
      purchase: "https://www.amazon.in/Kitchen-Khichdi-Divya-Ramachandran/dp/9358386215",
    },
    {
      title: "Yoga with Mr. Foxx",
      subtitle: "A playful introduction to yoga for little learners (ages 3–5), starring a sleepy fox and his animal friends. Hardbound edition available on demand.",
      cover: ASSETS.yogaFoxx,
      purchase: "mailto:divya.ovya@gmail.com?subject=Order%20Yoga%20with%20Mr.%20Foxx%20(Hardbound)&body=Hi%20Divya%2C%0A%0AI%27d%20like%20to%20order%20a%20hardbound%20copy%20of%20Yoga%20with%20Mr.%20Foxx.%0A%0ANumber%20of%20copies%3A%20%0AShipping%20address%3A%20%0A%0AThank%20you%21",
    },
  ],
  poetry: [
    {
      title: "Echoes of Illusions",
      subtitle: "Poems, 2019",
      purchase: "https://www.amazon.in/Echoes-Illusions-Divya-Ramachandran/dp/9360946060",
    },
    {
      title: "Fragments of a Full Heart",
      subtitle: "Poems, 2021",
      purchase: "https://www.amazon.in/Fragments-Full-Heart-Bits-pieces/dp/9369544143",
    },
    {
      title: "Uprooted",
      subtitle: "Poems on belonging, 2023",
      purchase: "https://www.amazon.in/People-Uprooted-Exodus-Pakistan-Bangladesh/dp/8194843057",
    },
  ],
  anthologies: [
    {
      title: "Eleven Vignettes: Slices of Life",
      subtitle: "Scholastic Writers Academy anthology — includes Divya's short story 'Lost Soles'.",
      cover: ASSETS.elevenVignettes,
      purchase: "https://www.amazon.in/Eleven-Vignettes-Slices-Life-Various/dp/9359542423",
    },
    {
      title: "We Matched. Unfortunately.",
      subtitle: "An anthology of real, funny, bizarre and unforgettable dating stories — curated with Prarthana Bhattacharjee Brennan.",
      cover: ASSETS.weMatched,
      purchase: "https://www.amazon.in/We-Matched-Unfortunately-Anthology-Unforgettable/dp/9376861361",
    },
  ],
};

export const ARTICLE_CATEGORIES = [
  "Creativity",
  "Play",
  "Education",
  "Personal Reflections",
  "Experiments in Living",
];

// Used as fallback if the Medium RSS feed fails to load.
export const ARTICLES = [
  {
    title: "Life as an Experiment",
    category: "Experiments in Living",
    excerpt:
      "What if a life were less a ladder and more a laboratory? Notes on living by hypothesis.",
    minutes: 7,
  },
  {
    title: "Validation is Human",
    category: "Personal Reflections",
    excerpt:
      "The myth of the self-sufficient artist, and the quiet courage of needing to be seen.",
    minutes: 5,
  },
  {
    title: "Impact Beyond Numbers",
    category: "Education",
    excerpt:
      "On the small, immeasurable things that change a classroom — and a child.",
    minutes: 8,
  },
  {
    title: "Multi-Passionate Living",
    category: "Creativity",
    excerpt:
      "A defence of the scattered, plural, joyful life — and the disciplines it secretly demands.",
    minutes: 6,
  },
  {
    title: "What Children Know About Play",
    category: "Play",
    excerpt:
      "Three years of observing kindergartens taught me what every curriculum forgets.",
    minutes: 9,
  },
  {
    title: "Drawing as Thinking",
    category: "Creativity",
    excerpt:
      "Why I sketch before I write — and what the pencil knows that the keyboard cannot.",
    minutes: 4,
  },
];

export const PUBLIC_WORK = [
  {
    title: "TEDx — Using Art to Ignite Ideas",
    description:
      "On why art is not a decoration on the side of education, but its central operating system.",
    href: "https://www.ted.com/talks/divya_ramachandran_using_art_to_ignite_ideas_spur_creativity_and_spread_joy",
  },
  {
    title: "The Happy Wall Project",
    description:
      "A community art initiative that turns ordinary walls into pockets of joy — featured in The Better India.",
    href: "https://thebetterindia.com/112436/painting-walls-divya-ramachandran-the-happy-wall-project/",
  },
  {
    title: "Curriculum Design",
    description:
      "Frameworks built with schools across India for play-based, arts-integrated learning.",
    href: "#",
  },
  {
    title: "Exhibitions",
    description:
      "Solo and group shows including Dubai with Sagar's Art Stream, HAAT of Art (Bangalore), and Rangoli Metro Art Centre with Cubbon Paints and the Bangalore Art Collective.",
    href: "#",
  },
  {
    title: "Doctoral Research",
    description:
      "PhD from SSBM Geneva, Switzerland — improving classroom experiences for special-needs learners using AR technology, including an underwater map that helps children practice difficult-to-pronounce sounds.",
    href: "#",
  },
];

export const MAGIC_INK = {
  title: "Magic Ink",
  tagline: "Children's storytelling & audiobook platform",
  blurb:
    "Hear Meera's adventures and other original kids' stories come alive in audio — songs, narration, and a little bit of mischief. The audio companion to the books on this shelf.",
  spotify: "https://open.spotify.com/show/0xp36OEl6cSqnGsXWpUA83",
  embed: "https://open.spotify.com/embed/show/0xp36OEl6cSqnGsXWpUA83?utm_source=generator&theme=0",
};

export const MUSIC = {
  songs: {
    title: "Music",
    subtitle: "Original songs, a cappella, and the occasional studio collaboration.",
    spotify: "https://open.spotify.com/artist/4fdjZXRvNr9DNhYJMKQIML?si=aKSXOH5KTU-kliz20hhWGw",
    embed: "https://open.spotify.com/embed/artist/4fdjZXRvNr9DNhYJMKQIML?utm_source=generator&theme=0",
  },
  flashJamImage: ASSETS.flashJam,
  storyWorldImage: ASSETS.storyWorld,
  projects: [
    {
      name: "Flash Jamboree",
      role: "Vocalist & troupe member",
      blurb: "Strangers walk in, a choir walks out. A flash of music, a lifetime of connection.",
    },
    {
      name: "A Cappella Journey",
      role: "Vocal arranger",
      blurb: "Five years of layered voices, harmonies, and friendship.",
    },
    {
      name: "Performances",
      role: "Singer-songwriter",
      blurb: "Festival stages, living rooms, and the in-between.",
    },
  ],
};
